import data_control from "../../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import { loveStoryPeople } from "./loveStoryConst";
import O1HD from "../../../../engines/gameEngine";
import loveStoryPrefab from "./loveStoryPrefab";
import loveStoryDetailPrefab from "./loveStoryDetailPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loveStoryItem extends cc.Component {

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Sprite,displayName:"头像节点"})
    headSp:cc.Sprite = null;

    @property({type:cc.Label,displayName:"钱文本"})
    lbCoin:cc.Label = null;

    @property({type:cc.Node,displayName:"激活节点"})
    activeNode : cc.Node = null;
    @property({type: cc.Label,displayName:"描述"})
    lbDesc : cc.Label = null;
    @property({type:cc.Prefab,displayName:"恋爱屋预制体"})
    loveHouseDetailPrefab : cc.Prefab = null;

    people:loveStoryPeople = null;

    mParentScript : loveStoryPrefab = null;


    registerParentScript( parentScript : loveStoryPrefab ){
        this.mParentScript = parentScript;
    }

    bindData(people:loveStoryPeople){
        this.people = people;
        this.updateItem().then();
    }

    async updateItem(){
        this.activeNode.active = true;
        let desc : string = "";
        switch ( this.people.peopleId ) {
            case "薇薇": desc = "看似人美心善的绿茶前任，追她用光了我大学生活费";break;
            case "小芳": desc = "青梅竹马两小无猜，若不是我爹阻拦已经步入婚姻殿堂";break;
            case "沈瑶瑶": desc = "据她自称是八国混血；口头禅是：抱歉，有钱真的可以为所欲为";break;
        }
        this.lbDesc.string = `${desc}`;
        let people = getOnePeopleById(this.people.peopleId);
        let headUrl:string = people.headUrl;
        this.lbName.string = this.people.peopleId;
        this.lbCoin.string = data_control.getNumberFormat(this.people.totalCoin);
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle);
        bundle.load(headUrl,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log("加载头像失败 # loveStoryShareItem",err);
                return;
            }
            this.headSp.spriteFrame = spr;
        });
    }

    /**
     * 邀请
     */
    onBtnInvite(){
        this.mParentScript.onBtnShare().then();
    }

    /**
     * 了解详情
     */
    onBtnGoDetail(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let loveHouseDetailNode = cc.instantiate( this.loveHouseDetailPrefab );
        O1HD.Canvas().addChild( loveHouseDetailNode );
        loveHouseDetailNode.getComponent(loveStoryDetailPrefab).bindData( this.people.peopleId );
    }

}
